import { render, staticRenderFns } from "./SendCoupon.vue?vue&type=template&id=4c1bf986&"
import script from "./SendCoupon.vue?vue&type=script&lang=js&"
export * from "./SendCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports